export default __webpack_public_path__ + "static/media/securepayments.eb785c71.svg";